<template lang="pug">
h3.text-h6.font-weight-bold.text-none
  slot
</template>

<script>
export default {
  name: 'SubHeader',
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  methods: {},
};
</script>
